import axiosClient from "./axiosClient";

export const getComplianceTypes = async () => {
  const res = await axiosClient.get("/compliance/types/");
  return res.data?.results || [];
};

export const getComplianceTypesForSettings = async () => {
  const res = await axiosClient.get("/compliance/types/manage/");
  return res.data?.results || [];
};

export const createComplianceType = async (data) => {
  const res = await axiosClient.post("/compliance/types/manage/", data);
  return res.data;
};

export const updateComplianceTypeSetting = async (typeId, data) => {
  const res = await axiosClient.put(`/compliance/types/${typeId}/update/`, data);
  return res.data;
};

export const createComplianceSchedule = async (data) => {
  const res = await axiosClient.post("/compliance/schedules/create/", data);
  return res.data;
};

export const createCommunalFireDoor = async (propertyId, data) => {
  const res = await axiosClient.post(`/properties/${propertyId}/compliance/fire-doors/create/`, data);
  return res.data;
};

export const getPropertyCompliance = async (propertyId, params = {}) => {
  const res = await axiosClient.get(`/properties/${propertyId}/compliance/`, { params });
  return res.data;
};

export const createComplianceTask = async (data) => {
  const isMultipart = data instanceof FormData;
  const res = await axiosClient.post("/compliance/tasks/create/", data, isMultipart
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : undefined);
  return res.data;
};

export const completeComplianceTask = async (taskId, data) => {
  const res = await axiosClient.put(`/compliance/tasks/${taskId}/complete/`, data);
  return res.data;
};

export const updateComplianceTask = async (taskId, data) => {
  const isMultipart = data instanceof FormData;
  const res = await axiosClient.put(`/compliance/tasks/${taskId}/update/`, data, isMultipart
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : undefined);
  return res.data;
};

export const deleteComplianceTask = async (taskId) => {
  const res = await axiosClient.delete(`/compliance/tasks/${taskId}/delete/`);
  return res.data;
};
